import { gql } from '@apollo/client';
import { USER, AUTO_COMPLETE_USERS, KUDOS_AWARD } from './Types';

export const CURRENT_USER = gql`
  query me {
    me {
      ${USER}
    }
  }
`;

export const CURRENT_ROUTE = gql`
  query currentRoute {
    currentRoute @client {
      __typename
      route
      params
    }
  }
`;

export const CURRENT_SERVICE = gql`
  query currentService {
    currentService @client {
      __typename
      service
    }
  }
`;

export const AUTO_COMPLETE = gql`
  query autoComplete($query: String!, $includeGroups: Boolean!){
    autoComplete(query: $query, includeGroups: $includeGroups) {
      ${AUTO_COMPLETE_USERS}
    }
  }
`;

export const GET_WALL = gql`
  query wall($view: String!, $pages: String, $lastSeen: String, $otherUserId: ID, $filterType: String, $receivedOnly: Boolean, $hashtag: String) {
    wall(view: $view, pages: $pages, lastSeen: $lastSeen, otherUserId: $otherUserId, filterType: $filterType, receivedOnly: $receivedOnly, hashtag: $hashtag) {
      __typename
      ... on KudosAward {
        ${KUDOS_AWARD}
      }
    }
  }
`;
